// extracted by mini-css-extract-plugin
export default {"table_value":"UsersInfo_table_value__Xybx3"};